import Head from 'next/head'
import { createClient } from 'services/prismic'

import { isPresent } from 'utils'

import prismicArticleToArticleHeaderProps from 'converters/prismicArticleToArticleHeaderProps'

import ArticleHeader from 'components/ArticleHeader'
import PrismicPage from 'components/PrismicPage'
import Spacer from 'components/Spacer'

export default function Article({ document }) {
  return (
    <>
      <Head>
        <title>{document.data.title}</title>
      </Head>
      <div
        style={{
          ...(isPresent(document.data['css_variable_--color-text']) && {
            '--color-text': document.data['css_variable_--color-text'],
          }),
          ...(isPresent(document.data['css_variable_--color-grey']) && {
            '--color-grey': document.data['css_variable_--color-grey'],
          }),
          ...(isPresent(document.data['css_variable_--color-gold-white']) && {
            '--color-gold-white': document.data['css_variable_--color-gold-white'],
          }),
          ...(isPresent(document.data['css_variable_--color-blue-grey']) && {
            '--color-blue-grey': document.data['css_variable_--color-blue-grey'],
          }),
          ...(isPresent(document.data.background_color) && {
            backgroundColor: document.data.background_color,
          }),
          color: 'var(--color-text)',
        }}
      >
        <ArticleHeader {...prismicArticleToArticleHeaderProps(document)} />
        <Spacer y={16} />
        <PrismicPage document={document} />
      </div>
    </>
  )
}

export async function getServerSideProps({ params, previewData }) {
  try {
    const prismic = createClient({ previewData })
    const document = await prismic.getArticle(params.uid)

    return {
      props: {
        document,
      },
    }
  } catch (e) {
    console.error(e)
    return { notFound: true }
  }
}
